import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MembersTableComponent } from '@app/areas/members/components';
import { PortalTheme } from '@app/@shared/models';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';

@UntilDestroy()
@Component({
  template: '<app-members-table [theme]="theme" />',
  styleUrls: ['./members.component.scss'],
  standalone: true,
  imports: [MembersTableComponent],
})
export class MembersComponent implements OnInit {
  protected theme!: PortalTheme;
  private readonly applicationProfileService = inject(ApplicationProfileService);

  ngOnInit(): void {
    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
